import type { RoastCounterState } from '../../hooks/useRoastCounter';
import { cn } from '../../lib/utils';

const STEAM_DELAYS = ['0ms', '900ms', '1800ms'];

export function RoastCounter({ roast }: { roast: RoastCounterState }) {
  const { temp, stage, isFirstCrack } = roast;
  const progress = Math.min(100, ((temp - 178) / (214 - 178)) * 100);

  return (
    <div className="absolute right-[clamp(24px,5vw,72px)] top-[clamp(24px,5vw,72px)] text-right">
      <div className="relative mb-2 flex h-[26px] justify-end gap-2" aria-hidden="true">
        {STEAM_DELAYS.map((delay) => (
          <span
            key={delay}
            className="h-[26px] w-[5px] animate-steam bg-gradient-to-t from-accent/[0.34] to-transparent blur-[2px]"
            style={{ animationDelay: delay }}
          />
        ))}
      </div>
      <div
        className={cn(
          'font-mono text-[44px] font-medium leading-none transition-colors duration-300',
          isFirstCrack ? 'text-accent' : 'text-ink',
        )}
      >
        {temp.toFixed(1)}°
      </div>
      <div className="mt-2 h-[2px] w-[140px] bg-line">
        <div className="h-full bg-accent" style={{ width: `${progress}%` }} />
      </div>
      <div
        className={cn(
          'mt-2 font-mono text-[10px] uppercase tracking-[0.14em] transition-colors duration-300',
          isFirstCrack ? 'text-accent' : 'text-ink',
        )}
      >
        {stage}
      </div>
    </div>
  );
}
